import { getLanguage } from 'api/utils/languageManagment';

export const setHtmlLang = () => {
  const lang = getLanguage();

  document.documentElement.setAttribute('lang', lang);
};
